import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "./firebase";
import { signOut, onAuthStateChanged } from "firebase/auth";

// 🎨 RENK PALETİ
const COLORS = {
  primary: '#6366f1',
  primaryHover: '#4f46e5',
  bg: {
    primary: '#0f0f0f',
    secondary: '#1a1a1a',
    card: '#1e1e1e',
    hover: 'rgba(255, 255, 255, 0.05)',
  },
  text: {
    primary: '#e5e5e5',
    secondary: '#a3a3a3',
    muted: '#525252',
  },
  border: '#333333',
  logoCyan: '#06b6d4',
  logoBlue: '#3b82f6',
  logoPurple: '#8b5cf6',
  logoPink: '#d946ef',
  danger: '#ef4444'
};

// 🖌️ SVG İKONLAR
const Icons = {
  Explore: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>,
  Studio: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12h5l3 9 4-17 3 8h5"/></svg>,
  Learn: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>,
  User: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
  Settings: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  LogOut: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  ChevronDown: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
  Plus: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
};

function Header({ user: propUser, onNewTrack, sticky = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [currentUser, setCurrentUser] = useState(propUser);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (propUser) {
      setCurrentUser(propUser);
      setAuthLoading(false);
    }
    else {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        setCurrentUser(user || null);
        setAuthLoading(false);
    });
      return () => unsubscribe();
    }
  }, [propUser]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const isActive = (path) => location.pathname === path;
  const displayUsername = currentUser?.displayName || currentUser?.email?.split('@')[0] || "User";
  const avatarLetter = displayUsername.charAt(0).toUpperCase();

  return (
    <header style={{...styles.header, position: sticky ? "sticky" : "relative"}}>
      <div style={styles.container}>
        
        {/* LOGO */}
        <div style={styles.logoSection} onClick={() => navigate('/')}>
          <div style={styles.logoIconWrapper}>
            <span style={styles.bracketLeft}>&lt;</span>
            <span style={styles.bracketRight}>&gt;</span>
          </div>
          <div style={styles.logoTextWrapper}>
            <span style={styles.textSound}>Sound</span>
            <span style={styles.textCode}>Code</span>
          </div>
        </div>

        {/* NAVIGATION */}
        <nav style={styles.nav}>
          <button
            onClick={() => navigate('/explorer')}
            style={{...styles.navButton, ...(isActive('/explorer') ? styles.navButtonActive : {})}}
            onMouseEnter={(e) => !isActive('/explorer') && (e.currentTarget.style.color = COLORS.text.primary)}
            onMouseLeave={(e) => !isActive('/explorer') && (e.currentTarget.style.color = COLORS.text.secondary)}
          >
            <Icons.Explore /> Explore
          </button>

          <button
            onClick={() => navigate('/studio')}
            style={{...styles.navButton, ...(isActive('/studio') ? styles.navButtonActive : {})}}
            onMouseEnter={(e) => !isActive('/studio') && (e.currentTarget.style.color = COLORS.text.primary)}
            onMouseLeave={(e) => !isActive('/studio') && (e.currentTarget.style.color = COLORS.text.secondary)}
          >
            <Icons.Studio /> Studio
          </button>

          <button
            onClick={() => navigate('/learn')}
            style={{...styles.navButton, ...(isActive('/learn') ? styles.navButtonActive : {})}}
            onMouseEnter={(e) => !isActive('/learn') && (e.currentTarget.style.color = COLORS.text.primary)}
            onMouseLeave={(e) => !isActive('/learn') && (e.currentTarget.style.color = COLORS.text.secondary)}
          >
            <Icons.Learn /> Learn
          </button>
        </nav>

        {/* USER AREA */}
        <div style={styles.userSection}>
          {authLoading ? (
           <div style={{ width: "150px", height: "42px" }} />
          ) : currentUser ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>

              
              {/* ✨ CREATE NEW TRACK BUTTON ✨ */}
              <button 
                onClick={() => {
                  console.log("🎯 New Track butonuna tıklandı");
                  console.log("📍 Şu anki sayfa:", location.pathname);
                  console.log("🔧 onNewTrack fonksiyonu var mı?", !!onNewTrack);
                  console.log("🔧 onNewTrack tipi:", typeof onNewTrack);
                  
                  if (location.pathname === '/studio' && onNewTrack) {
                    console.log("✅ onNewTrack çağrılıyor...");
                    onNewTrack();
                  } else {
                    console.log("🔄 Studio sayfasına yönlendiriliyor...");
                    navigate('/studio');
                  }
                }}
                style={styles.createButton}
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = COLORS.primaryHover}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = COLORS.primary}
              >
                <Icons.Plus /> <span>New Track</span>
              </button>

              <div style={styles.profileWrapper}>
                <button
                  onClick={() => setShowProfileMenu(!showProfileMenu)}
                  style={styles.profileButton}
                  onMouseEnter={(e) => e.currentTarget.style.borderColor = COLORS.text.secondary}
                  onMouseLeave={(e) => e.currentTarget.style.borderColor = COLORS.border}
                >
                  <div style={styles.avatar}>{avatarLetter}</div>
                  <span style={styles.username}>{displayUsername}</span>
                  <span style={{color: COLORS.text.secondary, display: 'flex'}}><Icons.ChevronDown /></span>
                </button>

                {showProfileMenu && (
                  <>
                    <div style={styles.overlay} onClick={() => setShowProfileMenu(false)} />
                    <div style={styles.dropdownMenu}>
                      <div style={styles.menuHeader}>
                        <div style={styles.menuAvatar}>{avatarLetter}</div>
                        <div style={styles.menuUserInfo}>
                          <div style={styles.menuUsername}>{displayUsername}</div>
                          <div style={styles.menuEmail}>{currentUser.email}</div>
                        </div>
                      </div>

                      <div style={styles.menuDivider} />

                      <button 
                        onClick={() => { navigate('/profile'); setShowProfileMenu(false); }}
                        style={styles.menuItem}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = COLORS.bg.hover}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <span style={{color: COLORS.text.secondary}}><Icons.User /></span> Profile
                      </button>

                      <button 
                        onClick={() => alert("Settings coming soon!")}
                        style={styles.menuItem}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = COLORS.bg.hover}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <span style={{color: COLORS.text.secondary}}><Icons.Settings /></span> Settings
                      </button>

                      <div style={styles.menuDivider} />

                      <button
                        onClick={handleLogout}
                        style={{...styles.menuItem, color: COLORS.danger}}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(239, 68, 68, 0.1)'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <Icons.LogOut /> Sign Out
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          ) : (
            <button
              onClick={() => navigate('/signin')}
              style={styles.loginButton}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = COLORS.primary}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = COLORS.border}
            >
              Sign In
            </button>
          )}
        </div>
      </div>
    </header>
  );
}

const styles = {
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1000,
    height: "72px", 
    width: "100%",
    backgroundColor: "#0f0f0f",
    backdropFilter: "blur(12px)",
    borderBottom: `1px solid ${COLORS.border}`,
  },
  container: {
    maxWidth: "1400px",
    margin: "0 auto",
    height: "100%",
    padding: "0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "24px",
  },
  
  logoSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    userSelect: "none",
  },
  logoIconWrapper: {
    display: "flex",
    alignItems: "center",
    fontSize: "26px",
    fontWeight: "800",
    letterSpacing: "-3px",
    fontFamily: "'JetBrains Mono', monospace",
  },
  bracketLeft: {
    background: `linear-gradient(135deg, ${COLORS.logoCyan}, ${COLORS.logoBlue})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  bracketRight: {
    background: `linear-gradient(135deg, ${COLORS.logoPurple}, ${COLORS.logoPink})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  logoTextWrapper: {
    display: "flex",
    alignItems: "center",
    fontSize: "22px",
    fontWeight: "700",
    fontFamily: "'Inter', sans-serif",
    letterSpacing: "-0.5px",
  },
  textSound: { color: COLORS.text.primary },
  textCode: { color: COLORS.logoBlue },

  nav: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  navButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 18px",
    backgroundColor: "transparent",
    color: COLORS.text.secondary,
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontFamily: "'Inter', sans-serif",
  },
  navButtonActive: {
    color: COLORS.text.primary,
    backgroundColor: COLORS.bg.hover,
  },

  userSection: { display: "flex", alignItems: "center" },
  
  createButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 20px",
    backgroundColor: COLORS.primary,
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.2s",
    boxShadow: "0 2px 10px rgba(99, 102, 241, 0.2)"
  },

  profileWrapper: { position: "relative" },
  profileButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "6px 14px 6px 6px",
    backgroundColor: "transparent",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "50px",
    cursor: "pointer",
    transition: "all 0.2s",
    height: "42px",
  },
  avatar: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.logoBlue})`,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "13px",
    fontWeight: "700",
  },
  username: {
    color: COLORS.text.primary,
    fontSize: "14px",
    fontWeight: "500",
  },
  
  loginButton: {
    padding: "10px 24px",
    backgroundColor: COLORS.bg.secondary,
    color: COLORS.text.primary,
    border: `1px solid ${COLORS.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },

  overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 },
  dropdownMenu: {
    position: "absolute",
    top: "calc(100% + 12px)",
    right: 0,
    backgroundColor: COLORS.bg.card,
    border: `1px solid ${COLORS.border}`,
    borderRadius: "12px",
    minWidth: "260px",
    boxShadow: "0 10px 40px -10px rgba(0,0,0,0.6)",
    zIndex: 1000,
    padding: "6px",
  },
  menuHeader: {
    padding: "16px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  menuAvatar: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.logoBlue})`,
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    fontWeight: "600",
  },
  menuUserInfo: { flex: 1, overflow: 'hidden' },
  menuUsername: { fontSize: "15px", fontWeight: "600", color: COLORS.text.primary },
  menuEmail: { fontSize: "12px", color: COLORS.text.secondary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  menuDivider: { height: "1px", backgroundColor: COLORS.border, margin: "6px 10px" },
  menuItem: {
    width: "100%",
    padding: "10px 14px",
    backgroundColor: "transparent",
    color: COLORS.text.primary,
    border: "none",
    borderRadius: "6px",
    textAlign: "left",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    transition: "background 0.1s",
  }
};

export default Header;